import AddPhoneForm from 'components/PhoneForm/AddPhoneFormComponent';
import AddPhoneFormContainer from 'components/PhoneForm/AddPhoneFormContainer';
import VerifyPhoneForm from 'components/PhoneForm/VerifyPhoneFormComponent';
import VerifyPhoneFormContainer from 'components/PhoneForm/VerifyPhoneFormContainer';

export { default as AddPhoneForm } from 'components/PhoneForm/AddPhoneFormComponent';
export { default as AddPhoneFormContainer } from 'components/PhoneForm/AddPhoneFormContainer';
export { default as VerifyPhoneForm } from 'components/PhoneForm/VerifyPhoneFormComponent';
export { default as VerifyPhoneFormContainer } from 'components/PhoneForm/VerifyPhoneFormContainer';

export default {
  AddPhoneForm,
  AddPhoneFormContainer,
  VerifyPhoneForm,
  VerifyPhoneFormContainer,
};
